import React, { useState, useEffect } from "react";

// Package Import

import {
	Typography,
	Box,
	useTheme,
	Grid,
	Paper,
	Chip,
	Stack,
	Button,
	Backdrop,
	CircularProgress,
	Snackbar,
	Alert,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import {makeStyles} from '@mui/styles';

// User Import

import {
	GlobeBlueIcon,
	ProfileIcon,
	PopulationServedIcon,
	InventoryIcon,
	HashIcon,
	UnitsDeliveredIcon,
	ExpiredDosesIcon,
	WastedDosesIcon,
	DomainIcon,
	EmailIcon,
	TempratureIcon,
	BatchIcon1,
	EditIcon1,
	Inactive,
	Active,
} from "../../Svg";
import Barchart from "../../pages/shared/Barchart";
import { RoutesUrls, ministryRoutes } from "../../Services/Routes/APP";
import { headersPost } from "../../Services/API";
import { COMMON_API_URLS } from "../../Services/Routes/API";
import { ROLE_METHODS, titlizeString } from "../../common/functions";
import ConfirmationDialogue from "../ConfirmationDialogue";
import { domain } from "../../Services/Routes/API";
import { useDecodedToken } from "../../Services/Routes/APP/PrivateRoute";

// Component

const NodeDetails = ({ node }) => {
	// Hooks

	const theme = useTheme();

	const navigate = useNavigate();

	// States
	const [barChartData, setBarChartData] = useState(null);
	const [nodeData, setNodeData] = useState(node);
	const [alertOpen, setAlertOpen] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const [alertIcon, setAlertIcon] = useState("error");
	const [nodeStatusModaEditDialogueOpen, setNodeStatusModaEditDialogueOpen] =
		useState(false);
	const [loaderOpen, setLoaderOpen] = useState(false);

	const nodeRole = nodeData?.role;
	const user = useDecodedToken();

	const useStyles = makeStyles({
        chipStyle: {
          color: "blue",
          borderRadius: 1,
          maxWidth: 100,
          width: 100,
        },
        typographystyle: {
          marginLeft: 16,
        },
      });
      const classes = useStyles();

	// vaccination details for barchart
	const getVaccinationDetails = () => {
		const data = {
			details_request: {
				view_level: nodeRole,
				view_level_id: nodeData?.id,
			},
		};
		headersPost(COMMON_API_URLS.GET_DASHBOARD_DATA, data)
			.then((res) => {
				if (res?.status === 200 && res?.data?.success) {
					setBarChartData(res.data?.barChartData);
				} else {
					setAlertOpen(true);
					setAlertMsg(res?.data?.message);
					setAlertIcon("warning");
				}
			})
			.catch((err) => {
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.ministryAdmin + ministryRoutes?.detailsDistrict);
				} else {
					setAlertOpen(true);
					setAlertMsg(response?.statusText);
					setAlertIcon("error");
				}
			});
	};

	const yearSixMonthsAgo = () => {
		let d = new Date();
		d.setMonth(d.getMonth() - 6);
		return d.getFullYear();
	};

	const currentYear = () => {
		let d = new Date();
		return d.getFullYear();
	};

	const handleAlertClose = () => {
		setAlertOpen(false);
		setAlertMsg("");
		setAlertIcon("error");
	};
	// life cycle

	useEffect(() => {
		if (!nodeData) {
			setNodeData(node);
		}
		getVaccinationDetails();
	}, [node]);

	const updateActiveToggle = (nodeData) => {
		const data = {
			[nodeRole]: {
				id: nodeData?.id,
				is_active: nodeData?.is_active ? false : true,
			},
		};
		setLoaderOpen(true);

		headersPost(ROLE_METHODS.roleBasedAPIRoute(nodeRole) + "/update", data)
			.then((res) => {
				setLoaderOpen(false);
				setNodeStatusModaEditDialogueOpen(false);
				if (res?.status === 200 && res?.data?.success) {
					setNodeData(res?.data?.states);
					setAlertMsg(res?.data?.message);
					setAlertIcon("success");
					setAlertOpen(true);
				} else {
					setAlertOpen(true);
					setAlertMsg(res?.data?.message);
					setAlertIcon("warning");
				}
			})
			.catch((err) => {
				setLoaderOpen(false);
				const { response } = err;
				if (response?.status === 401) {
					localStorage.clear();
					navigate(RoutesUrls?.root);
				} else {
					setAlertOpen(true);
					setAlertMsg(response?.statusText);
					setAlertIcon("error");
				}
			});
	};

	const handleNodeStatusModaEditDialogueClose = () => {
		setNodeStatusModaEditDialogueOpen(false);
	};

	// Render

	return (
		<Box>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
					<Paper>
						<Box padding={{ xs: 1, sm: 2 }}>
							<Box display={"flex"} justifyContent={"space-between"}>
								<Box>
									<Typography variant="h6" component="div">
										General information
									</Typography>
									<Typography sx={{ mb: 1.5 }} color="text.secondary">
										{nodeData?.name},{nodeData?.country}
									</Typography>
								</Box>
								{ROLE_METHODS.appBasedRole(nodeData?.role) ===
								ROLE_METHODS.getAppBased1stChildRole(
									ROLE_METHODS.appBasedRole(user?.role)
								) ? (
									<Box>
										<Stack
											direction="row"
											justifyContent="center"
											alignItems="center"
										>
											<Button
												variant="contained"
												onClick={() => {
													setNodeStatusModaEditDialogueOpen(true);
												}}
												size="small"
												sx={{
													padding: 0,
													borderRadius: 4,
													marginRight: 1,
												}}
											>
												{nodeData?.is_active ? <Inactive /> : <Active />}
											</Button>
											<Button
												color="primary"
												variant="contained"
												size="small"
												onClick={() => {
													navigate(
														`/${ROLE_METHODS.appBasedRole(
															user?.role
														)}/${ROLE_METHODS.pluralizeRole(
															ROLE_METHODS.appBasedRole(nodeRole)
														)}/edit`,
														{
															state: {
																node: nodeData,
															},
														}
													);
												}}
												sx={{
													borderRadius: 1,
													minWidth: 2,
													padding: 1,
												}}
											>
												<EditIcon1 />
											</Button>
										</Stack>
									</Box>
								) : null}
							</Box>

							{/* 1 ROW */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<GlobeBlueIcon />
									</Box>
									<Typography
										ml={2}
										sx={{ paddingTop: 1.8, textAlign: "left" }}
									>
										{nodeRole
											? titlizeString(ROLE_METHODS.appBasedRole(nodeRole))
											: ""}
									</Typography>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.name}
									/>
								</Box>
							</Grid>
							{/* 2nd Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<ProfileIcon />
									</Box>
									<Typography ml={2} sx={{ paddingTop: 1.8 }}>
										Population
									</Typography>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.population}
									/>
								</Box>
							</Grid>
							{/* 3rd Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<PopulationServedIcon />
									</Box>
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Population Served
										</Typography>

										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Updated at{" "}
											{nodeData?.updated_at
												? format(new Date(), "MM/dd/yyyy")
												: ""}
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.vaccinated || 0}
									/>
								</Box>
							</Grid>
							{/* 4th Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<InventoryIcon />
									</Box>{" "}
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Current Inventory
										</Typography>
										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Updated 30 Minutes ago
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										label="1000 Units"
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
									/>
								</Box>
							</Grid>
						</Box>
					</Paper>
					{barChartData && (
						<Grid item mt={2}>
							<Paper>
								<Box padding={{ xs: 1, sm: 2 }}>
									<Typography variant="h5">Monthly Overview</Typography>
									<Typography variant="p" color={"text.grayText"}>
										Population Served per month
									</Typography>
									<Barchart data={barChartData} />
									<Typography
										variant="body2"
										textAlign={"center"}
										style={{ marginTop: "25px" }}
									>
										{yearSixMonthsAgo == currentYear
											? `Year ${currentYear()}`
											: `Year ${yearSixMonthsAgo()} - ${currentYear()}`}
									</Typography>
								</Box>
							</Paper>
						</Grid>
					)}
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
					{/* <Grid container padding={2}> */}
					<Paper>
						<Box
							padding={{ xs: 1, sm: 2 }}
							// minWidth={{ xs: 300, sm: 780, lg: "400px" }}
						>
							<Typography variant="h6" component="div">
								Inventory information
							</Typography>
							<Typography sx={{ mb: 1.5 }} color="text.secondary">
								{nodeData?.name},{nodeData?.country}
							</Typography>
							{/* 1 ROW */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<HashIcon />
									</Box>
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Vaccine Batch
										</Typography>

										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Current
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.reference_number || 0}
									/>
								</Box>
							</Grid>
							{/* 2nd Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<BatchIcon1 />
									</Box>
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Batch Recieved
										</Typography>

										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Current Batch
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={
											nodeData?.received_date
												? format(
														new Date(nodeData?.received_date),
														"MM/dd/yyyy"
												  )
												: "MM/dd/yyyy"
										}
									/>
								</Box>
							</Grid>
							{/* 3rd Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<BatchIcon1 />
									</Box>
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Batch Expiry
										</Typography>

										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Current Batch
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={
											nodeData?.expiry_date
												? format(new Date(nodeData?.expiry_date), "MM/dd/yyyy")
												: "MM/dd/yyyy"
										}
									/>
								</Box>
							</Grid>
							{/* 4th Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<TempratureIcon />
									</Box>{" "}
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Storage Temprature
										</Typography>
										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Updated 30 Minutes ago
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.storage_temperature || "N/A"}
									/>
								</Box>
							</Grid>
							{/* 5th Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<UnitsDeliveredIcon />
									</Box>{" "}
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Units Delivered
										</Typography>
										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Updated 30 Minutes ago
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.quantity_dispatch}
									/>
								</Box>
							</Grid>
							{/* 6th Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<ExpiredDosesIcon />
									</Box>{" "}
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Expired Doses
										</Typography>
										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Updated 30 Minutes ago
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.quantity_expired || 0}
									/>
								</Box>
							</Grid>
							{/* 7th Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<WastedDosesIcon />
									</Box>{" "}
									<Box>
										<Typography
											variant="body1"
											ml={2}
											component="div"
											sx={{ paddingTop: 1 }}
										>
											Wasted Dos
										</Typography>
										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Updated 30 Minutes ago
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.quantity_damage || 0}
									/>
								</Box>
							</Grid>
							{/* 8th Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<EmailIcon />
									</Box>{" "}
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Email
										</Typography>
										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Updated 30 Minutes ago
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									{/* <Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.email || "N/A"}
									/> */}
									<Chip
                                     className={classes.chipStyle}
                                        label={nodeData?.email || "N/A"}
                                    />
								</Box>
							</Grid>
							{/* 9th Row */}
							<Grid
								container
								display={"flex"}
								justifyContent={"space-between"}
								sx={{ mb: 1.5 }}
							>
								<Box display={"flex"} alignItems={"center"}>
									<Box
										height={"60px"}
										width={"60px"}
										display={"flex"}
										alignItems={"center"}
										justifyContent={"center"}
										sx={{
											backgroundColor: `${theme.palette.secondary.dark}`,
											borderRadius: 1.5,
										}}
									>
										<DomainIcon />
									</Box>{" "}
									<Box>
										<Typography
											variant="body1"
											component="div"
											ml={2}
											sx={{ paddingTop: 1 }}
										>
											Domain
										</Typography>
										<Typography
											ml={2}
											color="text.secondary"
											sx={{ fontSize: "12px" }}
										>
											Updated 30 Minutes ago
										</Typography>
									</Box>
								</Box>
								<Box sx={{ paddingTop: 1.2 }}>
									<Chip
										sx={{
											minWidth: "70px",
											color: "blue",
											borderRadius: 1,
										}}
										label={nodeData?.domain || "N/A"}
									/>
								</Box>
							</Grid>
						</Box>
					</Paper>
					{/* </Grid> */}
				</Grid>
			</Grid>

			<ConfirmationDialogue
				data={nodeData}
				open={nodeStatusModaEditDialogueOpen}
				handleClose={handleNodeStatusModaEditDialogueClose}
				confirmHandler={() => {
					updateActiveToggle(nodeData);
				}}
			/>
			<Backdrop
				sx={{
					zIndex: theme.zIndex.drawer + 1,
					color: theme.palette.primary.main,
				}}
				open={loaderOpen}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
			<Snackbar
				open={alertOpen}
				autoHideDuration={6000}
				onClose={handleAlertClose}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<Alert onClose={handleAlertClose} severity={alertIcon}>
					{alertMsg}
				</Alert>
			</Snackbar>
		</Box>
	);
};

export default NodeDetails;
